import React from "react";
import { Dialog } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "../../hooks/useTranslation";

type WagerNoticeDialogProps = {
  open: boolean;
  onCancel: () => void;
  onProceed: () => void;
  paperTop?: string;
};

const WagerNoticeDialog: React.FC<WagerNoticeDialogProps> = ({ open, onCancel, onProceed, paperTop = "5rem" }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      fullScreen={false}
      maxWidth={false}
      open={open}
      onClose={onCancel}
      PaperProps={{
        style: {
          position: "absolute",
          top: paperTop,
          width: "min(92vw, 48rem)",
          margin: "1rem",
          background: "transparent",
          boxShadow: "none",
        },
      }}
    >
      <div className="px-4 py-3 rounded-[10px] shadow-[0_10px_28px_rgba(0,0,0,0.45)] bg-[var(--inputbox-color)]">
        <div className="flex items-start sm:items-center justify-between gap-3 mb-2.5">
          <div className="m-0 text-[14px] sm:text-[16px] font-semibold text-[#aeb0b5] whitespace-normal break-words sm:whitespace-nowrap sm:overflow-hidden sm:text-ellipsis">
            {t("casino.wageringNoticeMessage")}
          </div>
          <button
            type="button"
            aria-label="Close"
            onClick={onCancel}
            className="w-[30px] h-[30px] inline-flex items-center justify-center border-0 p-0 cursor-pointer bg-transparent text-white opacity-95 hover:opacity-85"
          >
            <CloseIcon sx={{ fontSize: 22 }} />
          </button>
        </div>

        <div className="flex items-center justify-center gap-3 mt-3">
          <button
            type="button"
            onClick={onCancel}
            className="flex-1 h-[46px] rounded-[10px] border-0 text-[14px] font-bold leading-none text-white bg-error-color active:scale-[0.99]"
          >
            {t("common.cancel")}
          </button>
          <button
            type="button"
            onClick={onProceed}
            className="flex-1 h-[46px] rounded-[10px] border-0 text-[14px] font-bold leading-none text-white bg-border-color active:scale-[0.99]"
          >
            {t("casino.proceedToLaunch")}
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export default WagerNoticeDialog;

